// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1sRgf","overflowing":"ReadFullNote_overflowing__3aeQm"};